<template>
  <fragment>
    <tr>
      <td>{{ getJCGuidelinesNames(awardIndex) }}</td>
      <td>{{ getJCGuidelinesInfo(awardIndex) }}</td>
      <td>{{ currencyFormat(award.generalDamages) }}</td>
      <td>
        <div class="a-form-inputs">
          <control :table-control="true">
            <input
              autocomplete="off"
              type="number"
              min="0"
              max="100"
              v-model.number="discount"
              style="min-width: 5em"
              v-field-control.required="{
                type: 'number',
                name: 'discount' + awardIndex,
                min: 0,
                max: 100,
              }"
              required
            />
          </control>
        </div>
      </td>
      <td>{{ currencyFormat(award.total) }}</td>
    </tr>
    <tr class="a-table--error" v-if="!getDiscountsValid">
      <td colspan="5">
        <control-error> The discount must be between 0 and 100 </control-error>
      </td>
    </tr>
  </fragment>
</template>

<script>
import FormValidator from "components/form/validator/mixin";
import currencyFormat from "mixins/currencyFormat";
import Control from "components/form/Control.vue";
import ControlError from "components/form/control/Error.vue";
import { Fragment } from "vue-fragment";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AwardValueRow",
  props: {
    awardIndex: Number,
  },
  computed: {
    ...mapGetters("personal/generalDamages", [
      "getAward",
      "getJCGuidelinesInfo",
      "getJCGuidelinesNames",
      "getDiscountsValid",
    ]),
    award() {
      return this.getAward(this.awardIndex);
    },
    discount: {
      get() {
        return this.award.discount;
      },
      set(value) {
        this.updateValue({index: this.awardIndex, key:"discount", value: value || 0});
      },
    },
  },
  mixins: [FormValidator, currencyFormat],
  components: { Control, ControlError, Fragment },
  methods: {
    ...mapActions("personal/generalDamages", ["updateValue"]),
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// AwardValueRow.vue?0fa9f429